import * as angular from "angular";
import {IController} from "angular";
import {AgentModel} from "../../angular/models/agent.model";
import {TaskModel} from "../../../tasks/models/task.model";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";

export class AgentPerformanceDetailsComponent implements IController {

  agent: AgentModel[];
  performanceDetails: any;
  tasks: TaskModel[];
  onClose: Function;
  onTaskClick: Function;
  onMouseEnterTask: Function;
  onMouseLeaveTask: Function;
  onMouseEnterIrregularity: Function;
  onMouseLeaveIrregularity: Function;

  public packagesDataMap: any;
  public taskIrregulartiesMap: any;
  public outOfServiceAreaIrregularties: any[];
  public completionDistanceFromTaskLocationIrregularties: any[];
  public purposeToServiceType: any;
  public distanceUnit: string;

  constructor(private tasksConstants, private splitService: SplitService) {
  }

  $onInit() {
    this.purposeToServiceType = this.tasksConstants.purposeToServiceType;
    this.distanceUnit = this.splitService.getSiteDistanceLargeUnit();
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.tasks) {
      if (this.tasks?.length) {
        this.initPackagesDataMap();
      }
    }

    if (changes.performanceDetails) {
      this.initIrregulartiesData();
    }
  }

  getTaskIndex(taskId) {
    return (this.tasks?.findIndex(t => t.id === taskId) || 0) + 1;
  }

  private initIrregulartiesData() {

    this.taskIrregulartiesMap = {};
    this.outOfServiceAreaIrregularties = [];
    this.completionDistanceFromTaskLocationIrregularties = [];

    if (!this.performanceDetails) {
      return;
    }

    this.performanceDetails.agentIrregularity?.outOfServiceArea?.forEach((item) => {
      const irregularity = {
        ...item,
        id: `outOfServiceArea-${item.fromDate}`
      };
      this.outOfServiceAreaIrregularties.push(irregularity);
    })

    this.performanceDetails.agentIrregularity?.completionDistanceFromTaskLocation?.forEach((item) => {
      const irregularity = {
        ...item,
        id: `completionLocationIrregularity-${item.taskId}`,
        type: 'taskCompletionLocationIrregularity'
      };

      if (!this.taskIrregulartiesMap[item.taskId]) {
        this.taskIrregulartiesMap[item.taskId] = [];
      }

      this.taskIrregulartiesMap[item.taskId].push(irregularity);
      this.completionDistanceFromTaskLocationIrregularties.push(irregularity);
    })

  }

  private initPackagesDataMap() {
    this.packagesDataMap = {};
    this.tasks.forEach((t) => {
      this.packagesDataMap[t.id] = {}
      let plannedPackages;
      if (t.packageList?.length) {
        plannedPackages = _.reduce(t.packageList[0].items, (sum, i) => {
          sum += i.count;
          return sum;
        }, 0);
      }
      this.packagesDataMap[t.id].planned = plannedPackages || 0;

      if (t.trackingDeparture?.missingItemIdList?.length) {
        const missingItems = t.packageList[0].items.filter(item => t.trackingDeparture?.missingItemIdList.includes(item.id));
        this.packagesDataMap[t.id].actual = _.reduce(missingItems, (sum, i) => {
          sum += i.count;
          return sum;
        }, 0);
      } else {
        this.packagesDataMap[t.id].actual = plannedPackages;
      }
    })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentPerformanceDetails', {
    bindings: {
      agent: '<',
      performanceDetails: '<',
      tasks: '<',
      onClose: '&',
      onTaskClick: '&',
      onMouseEnterTask: '&',
      onMouseLeaveTask: '&',
      onMouseEnterIrregularity: '&',
      onMouseLeaveIrregularity: '&',
    },
    template: require('./agent-performance-details.html').default,
    controller: AgentPerformanceDetailsComponent
  });
